var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6679 4.35248C11.9933 4.02704 12.521 4.02704 12.8464 4.35248L17.9047 9.41081C18.061 9.56709 18.1488 9.77905 18.1488 10.0001C18.1488 10.2211 18.061 10.433 17.9047 10.5893L12.8464 15.6477C12.521 15.9731 11.9933 15.9731 11.6679 15.6477C11.3425 15.3222 11.3425 14.7946 11.6679 14.4691L16.137 10.0001L11.6679 5.53099C11.3425 5.20555 11.3425 4.67791 11.6679 4.35248Z",
    fill: "#9091A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.31543 9.99984C2.31543 9.5396 2.68853 9.1665 3.14876 9.1665H17.1738C17.634 9.1665 18.0071 9.5396 18.0071 9.99984C18.0071 10.4601 17.634 10.8332 17.1738 10.8332H3.14876C2.68853 10.8332 2.31543 10.4601 2.31543 9.99984Z",
    fill: "#9091A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRight);
export default __webpack_public_path__ + "static/media/ic-arrow-right.bfac8428f4d8dc57b5e04ea8fd15c6bd.svg";
export { ForwardRef as ReactComponent };